export const GripIcon = ({ className }: { className?: string }) => {
	return (
		<svg
			className={className}
			width="6"
			height="12"
			viewBox="0 0 6 12"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
			<g fill="currentColor">
				<circle cx="1.5" cy="2" r="1.2" />
				<circle cx="4.5" cy="2" r="1.2" />
				<circle cx="1.5" cy="6" r="1.2" />
				<circle cx="4.5" cy="6" r="1.2" />
				<circle cx="1.5" cy="10" r="1.2" />
				<circle cx="4.5" cy="10" r="1.2" />
			</g>
		</svg>
	)
}
